export const gumusSponsorlar = [
  {
    id: 1,
    name: "Borsan",
    imageUrl: "/assets/sponsorlar/gumus/borsan.png",
    url: "https://www.borsan.com.tr/"
  },
  {
    id: 1,
    name: "Eti Bakır",
    imageUrl: "/assets/sponsorlar/gumus/etiBakir.png",
    url: "https://www.borsan.com.tr/"
  },
  {
    id: 2,
    name: "MARS SANAYİ ÜRN. AMBALAJ İTH. İHR. SAN. TİC. A.Ş.",
    imageUrl: "/assets/sponsorlar/gumus/mars.png",
    url: "https://marsambalaj.com.tr/"
  },
  {
    id: 2,
    name: "Samsu Börek",
    imageUrl: "/assets/sponsorlar/gumus/samsu-borek.png",
    url: "https://samsuborek.com.tr/"
  },
  {
    id: 2,
    name: "Simder",
    imageUrl: "/assets/sponsorlar/gumus/simder.png",
    url: "https://www.simder.org/"
  },
  {
    id: 2,
    name: "Simogg",
    imageUrl: "/assets/sponsorlar/gumus/simogg1.png",
    url: "https://www.simogg.com.tr/"
  },
  {
    id: 2,
    name: "UG Demir Çelik",
    imageUrl: "/assets/sponsorlar/gumus/ug-demir.png",
    url: "https://www.ugdemircelik.com/"
  }
]